import { render } from "./ForfeitButton.vue?vue&type=template&id=068ec2f6"
import script from "./ForfeitButton.vue?vue&type=script&lang=js"
export * from "./ForfeitButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/corentin/Documents/Projets/Wordle/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__